import * as tslib_1 from "tslib";
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { getActiveCharm } from 'owa-header-store';
import strings from 'owa-strings/owa-common-strings';
import { getHostLocation } from 'owa-url/lib/hostLocation';
import * as React from 'react';
import { getMailPath, getCalendarPath, getPeoplePath, getPhotoHubPath, getOwaUrlWithAddedQueryParameters, } from 'owa-url';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
var styles = require('./WafflePane.scss');
var classNames = require('classnames/bind');
var indexedReactDefaultPage = getMailPath() + 'default.aspx';
var indexedCalendarDefaultPage = getCalendarPath() + 'default.aspx';
var indexedPeopleDefaultPage = getPeoplePath() + 'default.aspx';
function createAppTile(displayName, icon, consumerHref, enterpriseHref, hoverBackground) {
    return {
        displayName: displayName,
        icon: icon,
        href: isControlFeatureEnabled('fwk-consumerWaffle') ? consumerHref : enterpriseHref,
        hoverBackground: hoverBackground,
    };
}
function isOwaMailReactLocation() {
    var lowercasePathname = getHostLocation().pathname.toLowerCase();
    if (lowercasePathname === getMailPath() || lowercasePathname === indexedReactDefaultPage) {
        return true;
    }
    return false;
}
function isOwaCalendarReactLocation() {
    var lowercasePathname = getHostLocation().pathname.toLowerCase();
    if (lowercasePathname === getCalendarPath() ||
        lowercasePathname === indexedCalendarDefaultPage) {
        return true;
    }
    return false;
}
function isOwaPeopleReactLocation() {
    var lowercasePathname = getHostLocation().pathname.toLowerCase();
    if (lowercasePathname === getPeoplePath() || lowercasePathname === indexedPeopleDefaultPage) {
        return true;
    }
    return false;
}
function isPhotoHubReactLocation() {
    var lowercasePathname = getHostLocation().pathname.toLowerCase();
    if (lowercasePathname === getPhotoHubPath()) {
        return true;
    }
    return false;
}
function getMailAppHref() {
    return isOwaMailReactLocation() ? '' : getMailPath();
}
function getPhotoHubAppHref() {
    return isPhotoHubReactLocation() ? '' : getPhotoHubPath();
}
function getCalendarAppHref() {
    return isOwaCalendarReactLocation() ? '' : getCalendarPath();
}
function getPeopleAppHref() {
    return isOwaPeopleReactLocation() ? '' : getPeoplePath();
}
function createPhotoHubAppTile() {
    var appHRef = getPhotoHubAppHref();
    return createAppTile(strings.appPhotos, "Photo2" /* Photo2 */, appHRef, appHRef, styles.appPhoto);
}
function isCalendarFlightSettingEnabled() {
    var userOptions = getUserConfiguration().UserOptions;
    if (userOptions && userOptions.ReactOptinSettings) {
        return userOptions.ReactOptinSettings.CalendarEnabled;
    }
    else {
        return false;
    }
}
function isPeopleFlightSettingEnabled() {
    var userOptions = getUserConfiguration().UserOptions;
    if (userOptions && userOptions.ReactOptinSettings) {
        return userOptions.ReactOptinSettings.PeopleEnabled;
    }
    else {
        return false;
    }
}
var Apps = computed(function () {
    return [
        createAppTile(strings.appMail, "OutlookLogo" /* OutlookLogo */, getMailAppHref(), getMailAppHref(), styles.appMail),
        createAppTile(strings.appCalendar, "Calendar" /* Calendar */, isControlFeatureEnabled('cal-react') || isCalendarFlightSettingEnabled()
            ? getCalendarAppHref()
            : getOwaUrlWithAddedQueryParameters({ path: '/calendar' }), isControlFeatureEnabled('cal-react') || isCalendarFlightSettingEnabled()
            ? getCalendarAppHref()
            : getOwaUrlWithAddedQueryParameters({ path: '/calendar' }), styles.appCalendar),
        createAppTile(strings.appPeople, "People" /* People */, isControlFeatureEnabled('fwk-peopleReact') || isPeopleFlightSettingEnabled()
            ? getPeopleAppHref()
            : getOwaUrlWithAddedQueryParameters({ path: '/people' }), isControlFeatureEnabled('fwk-peopleReact') || isPeopleFlightSettingEnabled()
            ? getPeopleAppHref()
            : getOwaUrlWithAddedQueryParameters({ path: '/people' }), styles.appPeople),
    ]
        .concat(isControlFeatureEnabled('doc-photohub') ? [createPhotoHubAppTile()] : [])
        .concat([
        createAppTile(strings.appOneDrive, "OneDrive" /* OneDrive */, 'https://onedrive.live.com', 'https://microsoft-my.sharepoint.com/_layouts/15/MySite.aspx?MySiteRedirect=AllDocuments', styles.appOneDrive),
        createAppTile(strings.appTasks, "CheckboxComposite" /* CheckboxComposite */, getOwaUrlWithAddedQueryParameters({ path: '/tasks' }), getOwaUrlWithAddedQueryParameters({ path: '/tasks' }), styles.appTasks),
        createAppTile(strings.appWord, "WordLogo" /* WordLogo */, 'https://office.live.com/start/Word.aspx?auth=1', 'https://office.live.com/start/Word.aspx?auth=2', styles.appWord),
        createAppTile(strings.appExcel, "ExcelLogo" /* ExcelLogo */, 'https://office.live.com/start/Excel.aspx?auth=1', 'https://office.live.com/start/Excel.aspx?auth=2', styles.appExcel),
        createAppTile(strings.appPowerPoint, "PowerPointLogo" /* PowerPointLogo */, 'https://office.live.com/start/PowerPoint.aspx?auth=1', 'https://office.live.com/start/PowerPoint.aspx?auth=2', styles.appPowerPoint),
        createAppTile(strings.appOneNote, "OneNoteLogo" /* OneNoteLogo */, 'https://www.onenote.com/notebooks?auth=1', 'https://www.onenote.com/notebooks?auth=2', styles.appOneNote),
        createAppTile(strings.appSway, "SwayLogoInverse" /* SwayLogoInverse */, 'https://sway.com', 'https://sway.com', styles.appSway),
    ])
        .concat(isControlFeatureEnabled('fwk-consumerWaffle')
        ? [
            createAppTile(strings.appSkype, "SkypeLogo" /* SkypeLogo */, 'https://web.skype.com/?source=owa', '', styles.appSkype),
            createAppTile(strings.appOffice, "OfficeLogo" /* OfficeLogo */, 'https://office.live.com/start/default.aspx?auth=1&nf=1', '', styles.appOffice),
            createAppTile(strings.appBing, "BingLogo" /* BingLogo */, 'https://www.bing.com/?FORM=MO0027', '', styles.appBing),
            createAppTile(strings.appMSN, "MsnLogo" /* MsnLogo */, 'https://www.msn.com/?OCID=CALHeader', '', styles.appMSN),
            createAppTile(strings.appFlow, "Flow" /* Flow */, 'https://flow.microsoft.com/manage/?utm_source=consumer_office&utm_medium=app_launcher&utm_campaign=consumer_referrals', '', styles.appFlow),
        ]
        : [])
        .concat(isControlFeatureEnabled('fwk-bookingsModule')
        ? [
            createAppTile(strings.appBookings, "BookingsLogo" /* BookingsLogo */, getOwaUrlWithAddedQueryParameters({ path: '/bookings' }), getOwaUrlWithAddedQueryParameters({ path: '/bookings' }), styles.appBookings),
        ]
        : []);
});
var AppsContextMenu = observer(function (props) { return (React.createElement("div", { className: styles.appsContainer }, Apps.get().map(function (appTile) {
    var tileClasses = classNames(styles.app, appTile.hoverBackground);
    var ariaProps = {
        role: AriaRoles.menuitem,
        label: appTile.displayName,
    };
    return (React.createElement("a", tslib_1.__assign({ "data-is-focusable": true, href: appTile.href, target: '_blank', className: tileClasses, onClick: props.onDismiss }, generateDomPropertiesForAria(ariaProps)),
        React.createElement(Icon, { className: styles.icon, iconName: appTile.icon }),
        React.createElement("div", { className: styles.text }, appTile.displayName)));
}))); });
var WaffleCharm = /** @class */ (function (_super) {
    tslib_1.__extends(WaffleCharm, _super);
    function WaffleCharm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WaffleCharm.prototype.render = function () {
        return (React.createElement(Panel, { className: styles.appPane, isLightDismiss: true, isOpen: getActiveCharm() === 5 /* WaffleCharm */, hasCloseButton: false, onDismiss: this.props.onDismiss, type: PanelType.smallFixedNear },
            React.createElement(AppsContextMenu, { onDismiss: this.props.onDismiss })));
    };
    WaffleCharm = tslib_1.__decorate([
        observer
    ], WaffleCharm);
    return WaffleCharm;
}(React.Component));
export default WaffleCharm;
//# sourceMappingURL=WafflePane.js.map